import { planTier } from "./planFeatures";

/* What a plan is called, wherever the app shows it.

   Tier 1 is sold as a free plan with a monthly reservation cap, so it is named
   for what it is rather than by the package row's "Essencial". Covers package 1
   and its yearly twin 4. */
export const displayPlanName = (pkg, t) =>
  planTier(pkg?.subscription_number) === 1
    ? t("ui.components.activeSubscription.freePlanName")
    : pkg?.name || "";

/* The package a restaurant is on: its own package number first (6 is yearly
   Completo), then the monthly twin of the same tier. */
export const packageForLevel = (packages, subLvl) => {
  if (!Array.isArray(packages)) return null;
  const raw = Number(subLvl || 0);
  const byNumber = number =>
    packages.find(pkg => Number(pkg.subscription_number) === Number(number));
  return byNumber(raw) || byNumber(planTier(raw)) || null;
};

const TIER_NAMES = { 2: "Ágil", 3: "Completo" };

export const planNameForRestaurant = (restaurant, packages, t) => {
  const pkg = packageForLevel(packages, restaurant?.sub_lvl);
  if (pkg) return displayPlanName(pkg, t);
  const tier = planTier(restaurant?.sub_lvl);
  if (tier === 1) return t("ui.components.activeSubscription.freePlanName");
  return TIER_NAMES[tier] || "";
};
